import React from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import { CommonLiterals } from "../../../../enums/StringLiterals/commonLiterals";
import { useFetchPdfUrl } from "../../../../hooks/useFetchPdfUrl";
import PdfRender from "../../../pdfRender/pdfRender";

interface PdfRendererTabProps {
  orderId?: string;
  status?: string;
}

const PdfRendererTab: React.FC<PdfRendererTabProps> = ({ orderId, status }) => {
  const { pdfUrl, isPdfLoading } = useFetchPdfUrl({
    orderId,
    status: status || "Approved",
    shouldFetch: !!orderId,
  });

  return (
    <div className="flex h-full w-full flex-col items-center justify-center border-1 border-primaryGray-15 bg-[#F7F9FA] p-4">
      {isPdfLoading ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 border-1 border-primaryGray-15 bg-[#F7F9FA]">
          <SpinningLoader />
          <span className="text-sm text-gray-600">
            {CommonLiterals.LOADING}
          </span>
        </div>
      ) : pdfUrl ? (
        <PdfRender file={pdfUrl} />
      ) : (
        <span className="text-sm text-gray-600">
          {CommonLiterals.NO_PDF_AVAILABLE}
        </span>
      )}
    </div>
  );
};

export default PdfRendererTab;
